import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BootError from './BootError';
import { configError } from './lib/supabase';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Configuração ausente para aqui, com explicação. Antes o app subia sem
// credencial, estourava durante o import e ficava em branco.
if (configError) {
  root.render(<BootError detalhe={configError} />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
